<app-dashboard
  [dashboardWidgetInfoGroup]="widgetInfoGroup"
  [CompanyId]="CompanyId"
></app-dashboard>
